import * as React from 'react';
export const IcCorporateEvent = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M10.44 5.62c.27.26.6.44.97.54.38.1.78.1 1.16 0 .38-.1.72-.29 1-.55.28-.27.48-.6.57-.96.1-.36.1-.75-.01-1.11-.1-.35-.29-.67-.56-.93-.27-.26-.6-.44-.97-.54-.38-.1-.78-.1-1.16 0-.38.1-.72.29-1 .55-.28.27-.48.6-.57.96-.1.36-.1.75.01 1.11.1.35.29.67.56.93zm8.88 6.13H5.02V10.36c0-.91.42-1.24.72-1.39.39.57 1.16.72 1.73.32.57-.4.71-1.18.31-1.75a1.23 1.23 0 00-1.73-.32c-.27.19-.46.48-.52.8-.64.22-1.46.86-1.46 2.33v1.8c-.04.09-.07.19-.07.29v1.63c0 .38.31.68.68.68H8v5.98c0 .56.45 1.01 1.01 1.01h5.98c.56 0 1.01-.45 1.01-1.01v-5.98h3.32c.38 0 .68-.31.68-.68v-1.63a.68.68 0 00-.68-.68v-.01zm-3.61-1.49c0-1.93-1.57-3.5-3.5-3.5h-.41c-1.93 0-3.5 1.57-3.5 3.5V11h7.41v-.74z'
      fill='currentColor'
    />
  </svg>
);
